// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Er4P","question":"styles_question__3RESi","description":"styles_description__1SP-8"};